<template>
    <div style="color: #666;font-size: 14px;">
        <b>{{msg}}</b>
        <button @click="ck">aaaa</button>
    </div>
</template>

<script>
    export default {
        name: "set",
        data(){
            return{
                msg:1
            }
        },
        methods:{
            ck(){
                // console.log("11111")
                this.msg ++;
            }
        }
    }
</script>
